const scrypt = require('./scryptSync')
scrypt.async = require('./scrypt')
module.exports = scrypt



//////////////////
// WEBPACK FOOTER
// ./node_modules/scryptsy/lib/index.js
// module id = L+0E
// module chunks = 0